import _regeneratorRuntime from "@babel/runtime/helpers/regeneratorRuntime";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var _excluded = ["dataSource", "size", "columns", "rowKey", "pagination"],
  _excluded2 = ["render"];
// import { lowLevelConvertToStoryboard } from "./raw-data-generate/convert.js";
import { parseDataSource } from "./expressions.js";
// import { getPreGeneratedAttrViews } from "./getPreGeneratedAttrViews.js";
// import { findObjectIdByUsedDataContexts } from "./findObjectIdByUsedDataContexts.js";
import { convertComponent } from "./convertComponent.js";
import { deepReplaceVariables } from "./deepReplaceVariables.js";
var columnUseBrickParams = ["cellData", "rowData"];
export default function convertTable(_x, _x2, _x3, _x4, _x5) {
  return _convertTable.apply(this, arguments);
}
function _convertTable() {
  _convertTable = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(component, mod, state, options, scope) {
    var _columns$;
    var properties, _ref, dataSource, size, columns, rowKey, pagination, restProps, parsedDataSource, configuredColumns, convertedColumns, _t;
    return _regeneratorRuntime().wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          properties = component.properties;
          _ref = properties, dataSource = _ref.dataSource, size = _ref.size, columns = _ref.columns, rowKey = _ref.rowKey, pagination = _ref.pagination, restProps = _objectWithoutProperties(_ref, _excluded);
          parsedDataSource = parseDataSource(dataSource); // const objectId = findObjectIdByUsedDataContexts(
          //   parsedDataSource.usedContexts,
          //   view.dataSources,
          //   view.variables
          // );
          // const attrViews = objectId
          //   ? await getPreGeneratedAttrViews(objectId)
          //   : undefined;
          configuredColumns = new Map(); // if (attrViews?.size && Array.isArray(columns)) {
          //   for (const column of columns) {
          //     if (column.render || typeof column.dataIndex !== "string") {
          //       continue;
          //     }
          //     const candidate = attrViews.get(column.dataIndex);
          //     if (candidate) {
          //       const brick = lowLevelConvertToStoryboard(candidate, ".cellData");
          //       if (brick) {
          //         brick.slot = `[${column.dataIndex}]`;
          //         configuredColumns.set(column.dataIndex, brick);
          //       }
          //     }
          //   }
          // }
          if (!Array.isArray(columns)) {
            _context2.next = 2;
            break;
          }
          _context2.next = 1;
          return Promise.all(columns.map(/*#__PURE__*/function () {
            var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref2) {
              var render, column, patterns, i, useBrick;
              return _regeneratorRuntime().wrap(function (_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    render = _ref2.render, column = _objectWithoutProperties(_ref2, _excluded2);
                    if (!render) {
                      _context.next = 2;
                      break;
                    }
                    patterns = new Map();
                    for (i = 0; i < render.params.length && i < columnUseBrickParams.length; i++) {
                      patterns.set(render.params[i], "DATA.".concat(columnUseBrickParams[i]));
                    }
                    _context.next = 1;
                    return Promise.all(render.children.map(function (child) {
                      return convertComponent(child, mod, state, options, scope);
                    }));
                  case 1:
                    useBrick = _context.sent.flatMap(function (child) {
                      return deepReplaceVariables(child, patterns);
                    });
                    return _context.abrupt("return", _objectSpread(_objectSpread({}, column), {}, {
                      useBrick: useBrick.map(function (item) {
                        return item.brick.startsWith(":") ? {
                          brick: "div",
                          children: [item]
                        } : item;
                      })
                    }));
                  case 2:
                    return _context.abrupt("return", typeof column.dataIndex === "string" && configuredColumns.has(column.dataIndex) ? _objectSpread(_objectSpread({}, column), {}, {
                      useChildren: "[".concat(column.dataIndex, "]")
                    }) : column);
                  case 3:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }));
            return function (_x6) {
              return _ref3.apply(this, arguments);
            };
          }()));
        case 1:
          _t = _context2.sent;
          _context2.next = 3;
          break;
        case 2:
          _t = columns;
        case 3:
          convertedColumns = _t;
          return _context2.abrupt("return", {
            brick: "eo-next-table",
            properties: _objectSpread(_objectSpread({
              dataSource: parsedDataSource.isString ? parsedDataSource.embedded : dataSource
            }, restProps), {}, {
              rowKey: rowKey !== null && rowKey !== void 0 ? rowKey : Array.isArray(columns) ? (_columns$ = columns[0]) === null || _columns$ === void 0 ? void 0 : _columns$.key : undefined,
              columns: convertedColumns,
              themeVariant: "elevo",
              scrollConfig: {
                x: "max-content"
              }
            }, options.expanded ? {
              bordered: true,
              pagination: pagination,
              size: "large"
            } : {
              size: "middle",
              pagination: false
            }),
            children: configuredColumns.size > 0 ? Array.from(configuredColumns.values()) : []
          });
        case 4:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _convertTable.apply(this, arguments);
}
//# sourceMappingURL=convertTable.js.map